// TODO: Need to refactor: this code the same as
//  wgnp/static_source/components/sms_verification_code_form/index.js
import withRender from './flashcall_verification_cellphone_recovery_form.vue.html';

import promisifiedAjaxRequest from '../../helpers/ajaxrequest/promisifiedAjaxRequest';
import promisifiedPrepareErrors from '../../helpers/promisifiedPrepareErrors';

import BMessageError from '../b_message_error/b_message_error';
import InputError from '../input_error/input_error';

import SmsVerificationResendCellphoneRecovery, {
    RESEND_CELLPHONE_RECOVERY_EVENT,
} from '../sms_resend_cellphone_recovery';

import Spinner from '../spinner/spinner';

import clearInputErrorsMixinConstructor from '../../mixins/clearInputErrors';
import getErrorTypeMixin from '../../mixins/getErrorType';

const clearInputErrorsMixin = clearInputErrorsMixinConstructor({
    code: {
        errorTypes: ['code'],
        resetProgrammatically: true,
    },
});

export default withRender({
    name: 'flashcall-verification-cellphone-recovery-form',

    mixins: [clearInputErrorsMixin, getErrorTypeMixin],

    components: {
        BMessageError,
        InputError,
        SmsVerificationResendCellphoneRecovery,
        Spinner,
    },

    props: {
        isTimerActive: {
            type: Boolean,
            default: false,
        },
        cancelButtonText: {
            type: String,
        },
        cancelOperationUrl: {
            type: String,
            required: true,
        },
        codeInputPlaceholder: {
            type: String,
        },
        codeLength: {
            type: Number,
            required: true,
        },
        operation: {
            type: String,
            required: true,
        },
        submitButtonText: {
            type: String,
        },
        submitUrl: {
            type: String,
            required: true,
        },
        qaDataAttributes: {
            type: Object,
            default: () => ({}),
        },
    },

    mounted() {
        this.$nextTick(() => {
            const currentUrl = window.location.href;

            if (currentUrl.includes('account/cellphone_recovery')) {
                if (this.$refs.smsTplForm) {
                    this.$refs.smsTplForm.classList.add('two-fa-steps_style_outside');
                }
            }
        });
    },

    data() {
        return {
            templatePrefix: 'js-tmpl-flashcall-verification-cellphone-recovery-form-error',

            ERRORS_TYPES: {
                code: ['flashcall:invalid_length', 'flashcall:invalid', 'flashcall:required, captcha:invalid'],
                captcha: ['captcha:invalid'],
            },

            processing: false,
            error: false,
            errors: [],
            errorsExtras: {},

            code: '',
        };
    },

    computed: {
        migSubmitUrl() {
            return this.$store.state.cellphone_recovery.responseUrlValidate;
        },
        actualSubmitUrl() {
            return this.migSubmitUrl || this.submitUrl;
        },
        mainErrorParams() {
            const {
                errorsExtras, errorsTemplates, requestNewCode, userCellphone, toggleResendTip,
            } = this;

            return {
                template: errorsTemplates.main,
                data: {
                    userCellphone,
                    ...errorsExtras,
                },
                methods: {
                    requestNewCode,
                    toggleResendTip,
                },
            };
        },
        userCellphone() {
            return this.$store.state.cellphone_recovery.cellphone;
        },
        compiledCodeLength() {
            return this.notificationType === 'flash_call'
                ? this.$store.state.cellphone_recovery.responseCodeLength
                : this.codeLength;
        },
        displayCodeLength() {
            return this.$store.state.cellphone_recovery.responseCodeLength;
        },
        notificationType() {
            return this.$store.state.cellphone_recovery.notificationType;
        },
        twofactorMethod() {
            return this.$store.state.cellphone_recovery.twofactorMethod;
        },
        errorsTemplates() {
            if (this.errorType.main) {
                return {
                    main: this.getErrorMessage(this.errors[0], null, 'js-tmpl-errors-process_error'),
                };
            }

            return Object.entries(this.errorType).reduce(
                (templates, [errorType, isErrorActive]) => {
                    if (this.ERRORS_TYPES[errorType] && isErrorActive) {
                        const error = this.ERRORS_TYPES[errorType].find(err => this.errors
                            .includes(err));

                        let errorTemplate;
                        if (error === 'flashcall:invalid_length') {
                            errorTemplate = this.getErrorMessage(error, {
                                number: this.displayCodeLength,
                            });
                        } else {
                            errorTemplate = this.getErrorMessage(error);
                        }

                        return Object.assign(templates, {
                            [errorType]: errorTemplate,
                        });
                    }

                    return templates;
                }, {}
            );
        },
    },

    methods: {
        focusCodeInput() {
            this.$refs.code.focus();
        },
        validateForm() {
            this.error = false;

            if (this.code.trim().length === 0) {
                return ['flashcall:required'];
            }

            const digitsRawRegexp = `^[0-9]{1,${this.compiledCodeLength}}$`;
            const digitsRegexp = new RegExp(digitsRawRegexp);

            if (!digitsRegexp.test(this.code)) {
                return ['flashcall:invalid'];
            }

            if (this.code.trim().length !== this.compiledCodeLength) {
                return ['flashcall:invalid_length'];
            }

            return null;
        },
        async submitForm(e) {
            if (this.processing) {
                return;
            }

            const verificationErrors = this.validateForm();

            if (verificationErrors) {
                this.error = true;
                this.errors = verificationErrors;
                this.code = '';
                this.focusCodeInput();
                return;
            }

            this.processing = true;

            try {
                const form = e.target;
                const url = form.action;
                const data = new FormData(form);
                const result = await promisifiedAjaxRequest({
                    url,
                    data,
                    method: 'POST',
                });

                this.$emit('submit-success', result);
            } catch (xhrError) {
                const { errors, errorsExtras } = await promisifiedPrepareErrors(xhrError);

                this.errors = errors;
                this.errorsExtras = errorsExtras;
                this.error = true;

                this.$emit('submit-error', xhrError);
            }

            this.processing = false;
        },
        requestNewCode() {
            if (this.isTimerActive) {
                return;
            }
            this.$refs.resendCellphoneRecoveryComponent.$emit(RESEND_CELLPHONE_RECOVERY_EVENT);
            this.error = false;
        },
        async onResendCodeError(xhrError) {
            const { errors, errorsExtras } = await promisifiedPrepareErrors(xhrError);

            this.errors = errors;
            this.error = true;
            this.errorsExtras = errorsExtras;
        },
        toggleResendTip() {
            this.$refs.resendCellphoneRecoveryComponent.toggleTip();
        },
    },
});
